/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { type JSX } from 'react';

import { getMarketingStatusTagForSlug } from 'bundles/product-card/components/utils/marketingTagUtils';
import NewAiBadge from 'bundles/unified-description-page-common/components/shared/badges/NewAiBadge';
import TopAiProgramBadge from 'bundles/unified-description-page-common/components/shared/badges/TopAiProgramBadge';
import TrendingRightNowBadge from 'bundles/unified-description-page-common/components/shared/badges/TrendingRightNowBadge';
import TopInstructorBadge from 'bundles/unified-description-page-common/components/shared/instructors/TopInstructorBadge';
import { shouldShowNewAiSkillsBadge } from 'bundles/unified-description-page-common/utils/shouldShowNewAiSkillsBadge';

const MAX_HERO_PILLS = 3; // new hard cap on max pills shown

const styles = {
  container: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--cds-spacing-150);
    flex-wrap: wrap;
  `,
};

type Props = {
  slug?: string;
  isTopInstructor?: boolean;
};

const HeroBadges = ({ slug, isTopInstructor }: Props) => {
  const marketingTag = slug ? getMarketingStatusTagForSlug(slug) : undefined;

  const badgeList: JSX.Element[] = [];
  if (isTopInstructor) {
    badgeList.push(<TopInstructorBadge key="top-instructor" />);
  }
  if (marketingTag?.category === 'top-ai-program') {
    badgeList.push(<TopAiProgramBadge key="top-ai-program" marketingTag={marketingTag} slug={slug} />);
  } else if (marketingTag?.category === 'trending-now') {
    badgeList.push(<TrendingRightNowBadge key="trending-now" marketingTag={marketingTag} slug={slug} />);
  } else if (shouldShowNewAiSkillsBadge(slug)) {
    badgeList.push(<NewAiBadge key="new-ai-skills" slug={slug} />);
  }
  const heroBadges = badgeList.slice(0, MAX_HERO_PILLS);

  return <div css={styles.container}>{heroBadges}</div>;
};

export default HeroBadges;
